import React from 'react';
import { TreeNodeType } from '../../../../../../lib/types/types';
import FinanzierungsplanGlobal, { getFormStrucFinanzierungsplanGlobal } from './content/FinanzierungsplanGlobal';

export const TreeStructureAntragFinanzierungsPlanGlobal = (application: any, hasComment?: boolean) => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Ausgaben- und Finanzierungsplan',
			content: <FinanzierungsplanGlobal />,
			formStruc: getFormStrucFinanzierungsplanGlobal(application),
			hasComment: hasComment,
			isSummaryReport: true,
		},
	];

	return treeNodes;
};
